import React from "react";
import { useIntl } from "react-intl";
import AppError from "../app-error";
import messages from "./access-denied-error-messages";

const AccessDeniedError = () => {
  const { formatMessage } = useIntl();
  return (
    <AppError
      title={formatMessage(messages.accessDenied)}
      description={formatMessage(messages.notPermitted)}
    >
      <span></span>
    </AppError>
  );
};

export default AccessDeniedError;
